import Loading from './loading'

export default Loading



// WEBPACK FOOTER //
// ./web/components/loading/index.js